import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { importSync } from '@embroider/macros';
import Component from '@glimmer/component';

import can from 'ember-can/helpers/can';
import { t } from 'ember-intl';

import Button from 'umg-ember-backend/components/ui/button';
import Modal from 'umg-ember-backend/components/ui/modal';
import Window from 'umg-ember-backend/components/ui/window';
import recordHeadlineOrNew from 'umg-ember-backend/helpers/record-headline-or-new';
import recordOverline from 'umg-ember-backend/helpers/record-overline';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

export default class PageBuilderContentItemsItemEntity extends Component {
  // Services
  @service confirm;
  @service recordRelationships;
  @service recordStatus;

  // Getter and setter
  getRecordDetailForm = (entity) => {
    const module = importSync(
      `../../../../record-detail/forms/${getRecordType(entity)}`,
    );

    return module.default;
  };

  get isSaveDisabled() {
    return this.recordStatus.isDisabled(this.args.model ?? this.args.mlp);
  }

  getIsDisabled = (entity) => {
    return this.recordStatus.isDisabled(entity);
  };

  // Functions
  confirmRollbackChanges = async () => {
    const scope = 'confirm.discard';
    const entity = this.args.entity;

    if (!this.recordRelationships.hasDirtyFields(entity)) {
      return this.args.onClose();
    }

    let ok = await this.confirm.ask(`${scope}.title`, `${scope}.message`);

    if (!ok) {
      return false;
    }

    const isNew = entity.isNew;
    this.recordRelationships.rollback(entity);
    entity.rollbackAttributes();
    this.args.onClose();

    if (isNew) {
      this.args.onDiscardNewEntity?.();
    }
  };

  // Template
  <template>
    <Modal
      @dataDependencies={{@entity}}
      @onClose={{this.confirmRollbackChanges}}
      as |entity onClose|
    >
      <Window
        @onBodyScroll={{@onBodyScroll}}
        @scrollPosition={{@scrollPosition}}
      >
        <:overline>
          {{recordOverline entity}}
        </:overline>

        <:title>
          {{recordHeadlineOrNew entity}}
        </:title>

        <:body>
          {{#let (this.getRecordDetailForm entity) as |RecordDetailForm|}}
            <RecordDetailForm
              @model={{entity}}
              @recordType={{getRecordType entity}}
              @mlp={{@mlp}}
              @newsletterArtist={{@mlp.artist}}
              @loadLegalContext={{@loadLegalContext}}
              @showErrors={{@showErrors}}
            />
          {{/let}}
        </:body>

        <:bottombar>
          {{#if (can 'update' entity)}}
            <Button
              @disabled={{this.isSaveDisabled}}
              @icon='save'
              @label={{t 'page_builder.content_items.item.entity.save'}}
              {{on 'click' (fn @onSaveEntity entity)}}
            />
          {{/if}}

          <Button
            @disabled={{this.getIsDisabled entity}}
            @icon='close'
            @label={{t 'page_builder.content_items.item.entity.cancel'}}
            @style='grey'
            {{on 'click' onClose}}
          />
        </:bottombar>
      </Window>
    </Modal>
  </template>
}
